import { render, staticRenderFns } from "./ResearchList.vue?vue&type=template&id=72afdfb2&scoped=true"
import script from "./ResearchList.vue?vue&type=script&lang=js"
export * from "./ResearchList.vue?vue&type=script&lang=js"
import style0 from "./ResearchList.vue?vue&type=style&index=0&id=72afdfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afdfb2",
  null
  
)

export default component.exports